import { useMutation } from '@tanstack/react-query';
import { useRouter } from 'next/router';
import { useMount } from 'react-use';
import { Button, Loader } from 'ui';
import { putAmbassadorApply } from '~/api/user';
import AmbassadorQualifyList from '~/components/Ambassadors/AmbassadorQualifyList';
import Layout from '~/components/Layout';
import { useModals } from '~/contexts/ModalsContext';
import { useSession } from '~/contexts/SessionContext';
import {
  fireClickedAmbassadorApply,
  fireVisitedAmbassadorApply,
} from '~/services/analytics/events/ambassadors';
import { CustomNextPage } from '~/typings/custom-next';

interface Props {}

const AmbassadorApplyPage: CustomNextPage<Props> = () => {
  const router = useRouter();
  const { loggedIn } = useSession();
  const modals = useModals();

  const { mutate, isLoading } = useMutation(putAmbassadorApply, {
    onMutate: () => {
      fireClickedAmbassadorApply();
    },
    onSuccess: () => {
      router.push('/ambassador/accepted');
    },
    onError: () => {
      router.push('/ambassador/rejected');
    },
  });

  function handleClickApply() {
    if (loggedIn) {
      mutate();
    } else {
      modals.openModal('loginRegister', {
        defaultView: 'login',
        contextMessage: 'Log in to apply for the ambassador program',
        onSuccessfulLogin: () => {
          mutate();
        },
      });
    }
  }

  useMount(fireVisitedAmbassadorApply);

  return (
    <Layout title="Ambassador Program" className="max-w-sm">
      <h1 className="mb-8 mt-4 text-center">Ambassador Program</h1>

      <section className="prose prose-sm">
        <h2>PERKS</h2>
        <ul>
          <li>
            Join our team of ambassadors helping us make sports more affordable.
          </li>
          <li>
            Earn 2x referral credits when people join with your referral code
          </li>
          <li>
            Compete for prizes, and swag for referring new users to
            SidelineSwap.
          </li>
          <li>Get behind the scenes access to the team at SidelineSwap.</li>
        </ul>
      </section>

      <section className="prose prose-sm my-6">
        <h2>HOW TO QUALIFY</h2>
        <AmbassadorQualifyList />
      </section>

      {isLoading ? (
        <Loader loading />
      ) : (
        <Button fluid onClick={handleClickApply}>
          Apply
        </Button>
      )}
    </Layout>
  );
};

export default AmbassadorApplyPage;
